module.exports = __webpack_public_path__ + "img/vast-booster-1.36ff991f.jpg";